import React from 'react';

import { TanStackQueryProvider } from '../tanStack/TanStackQueryProvider';

type ProviderProps = { children: JSX.Element };

export const PaymentsQueryProvider = ({ children }: ProviderProps): JSX.Element => {
  return <TanStackQueryProvider>{children}</TanStackQueryProvider>;
};
